import {
    SET_ATTACHMENTS,
    DEL_ATTACHMENT,
} from '../../actions/attachments';

export default function tasks(state = {}, action) {
    switch (action.type) {
        case SET_ATTACHMENTS:
            return Object.assign({}, state, action.payload);
        case DEL_ATTACHMENT:
            // Remove attachment from the state
            for (let i = 0; i < state.currentAttachments.length; i++) {
                if (state.currentAttachments[i].id == action.payload.deleteAttachment) {
                    state.currentAttachments.splice(i, 1);
                }
            }
            return Object.assign({}, state, action.payload);
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/attachments/index.js